<template>
     <loading-container :state="state" errormsg="Beim Laden ist ein Fehler aufgetreten.">
      <button v-if="currentSiteInLinklist" @click="toggleLinklisteLink()" class="btn btn-icon btn-icon-extend text-primary mw-0 px-2 mw-0 btn-star"
      :class="{ 'mlactive': currentSiteInLinklist, '': !currentSiteInLinklist }"
          type="button" > Gemerkt
            <i class="fa-regular fa-star"></i>
            <span class="sr-only">Seite von der Merkliste entfernen</span>
        </button>
      <button v-else @click="toggleLinklisteLink()" class="btn btn-icon btn-icon-extend text-primary mw-0 px-2 mw-0 btn-star"
      :class="{ 'mlactive': currentSiteInLinklist, '': !currentSiteInLinklist }"
          type="button" > Merken
            <i class="fa-regular fa-star"></i>
            <span class="sr-only">Seite zur Merkliste hinzufügen</span>
          </button>
    </loading-container>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import LoadingMixin from './mixins/LoadingMixin'
import LoadingContainer from './components/structure/LoadingContainer.vue'
import { sanitizeUrl } from '@braintree/sanitize-url'
import CONFIG from '@/config/config'
import { BmfwfLinkResolved } from './models/BmfwfLinkverwaltung'
import linkverwaltungService from './services/linkverwaltungService'

export default defineComponent({
  props: {
    uuid:{
      type:String,
      required:true
    },
    seitenname:{
      type:String,
      required:true
    },
  },
  name: 'WidgetSeiteMerken',
  mixins: [
    LoadingMixin
  ],
  components: {
    LoadingContainer
  },
  data() {
    return {
      list: [] as BmfwfLinkResolved[],
      sanitizeUrl: sanitizeUrl,
      currentSiteInLinklist: false ,
      loadingStateFromServer: true,
      deleteId:'',
    }
  },

  created() {
    fetch(CONFIG.baseApiUrl+'bmfwf/v1/favorites',{
      method: 'GET',
      headers:{
          'Content-Type':'application/json'
        }
    })
    .then( response => response.json())
    .then( jsonResponse =>{
      const currentSite= jsonResponse.find((linkverwaltunglink:any)=> linkverwaltunglink.internalUuid=== this.uuid)
      if(currentSite){
        this.currentSiteInLinklist=true
        this.deleteId=currentSite.id
      }

      this.handleSuccess()
    }
    )
    .catch( this.handleError)
  },


  methods: {

    toggleLinklisteLink(){

    if (this.currentSiteInLinklist){
      linkverwaltungService.removeLinkBmfwf(this.deleteId)
      .then(this.handleSuccess)
      .catch(this.handleError)
      .finally(() => {
            location.reload()
         })
      }
    else{
      linkverwaltungService.addLinkBmfwf(this.uuid, this.seitenname)
      .then(this.handleSuccess)
      .catch(this.handleError)
      .finally(() => {
            location.reload()
         })
      }
    }
  }
})
</script>
<style scoped>

template{
  display: block;
}
.btn-star.mlactive .fa-star {
  font-weight: 900;
}
.btn-star{
  min-width: 110px;
}
</style>
